module.exports = __webpack_public_path__ + "static/media/bussiness_policy_img6.18b8200a.png";